import { UseSignaturePaymentENTParams } from '../../../../../../hooks/fetchers/useSignaturePaymentENT/useSignaturePaymentENT.types';
import { BaseResponse } from '../../../../../../types/api/api.types';
import { RegisterResponse } from '../../../../../../types/api/endpoints/auth/register.types';
import { Code } from '../../../../../../types/models/code/code.types';
import { AUTH_ENDPOINTS } from '../../../../../../utils/api/endpoints/authEndpoints';
import { CODES_ENDPOINTS } from '../../../../../../utils/api/endpoints/codesEndpoints';
import { PAYMENT_ENDPOINTS } from '../../../../../../utils/api/endpoints/paymentEndpoints';
import { RegisterConfirmationStepFormSchema } from './RegisterConfirmationBisStepForm.types';

const PREFIX = '[registerNAFQuery]';

export const REGISTER_NAF_QUERY_KEY = 'REGISTER_NAF';

export const registerNAFQuery = async (
  fieldsOfActivity: RegisterConfirmationStepFormSchema['fieldsOfActivity']
) => {
  console.log(PREFIX, `Adding NAF codes to company...`);

  const response = await AUTH_ENDPOINTS.fieldsOfActivity({
    fieldsOfActivity: fieldsOfActivity as string[],
  });

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Added NAF codes to company.`);
  return json as RegisterResponse;
};

const NAF_PREFIX = '[registerNAFandTransactionQuery]';

export const REGISTER_NAF_AND_TRANS_QUERY_KEY = 'REGISTER_NAF_AND_TRANS';

export const registerNAFandTransactionQuery = async (params: {
  amount: number;
  fieldsOfActivity: string[];
  duration: number;
  code?: Code;
  currentTime: string;
}) => {
  console.log(NAF_PREFIX, `Adding NAF codes to company...`);

  const response = await AUTH_ENDPOINTS.fieldsOfActivityAndTransactions(params);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(NAF_PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Added NAF codes to company.`);
  return json as RegisterResponse;
};

const CODE_PREFIX = '[checkCodeQuery]';

export const CHECK_CODE_QUERY_KEY = 'CHECK_CODE';

export const checkCodeQuery = async (code: string) => {
  console.log(CODE_PREFIX, `Checking code validity...`);

  const response = await CODES_ENDPOINTS.check(code);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(CODE_PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(CODE_PREFIX, `Checked code validity.`);
  return json as Code;
};


const SIMULATE_PAYMENT_PREFIX = '[simulatePaymentQuery]';

export const SIMULATE_PAYMENT_QUERY_KEY = 'SIMULATE_PAYMENT';

export const simulatePaymentQuery = async (data: UseSignaturePaymentENTParams) => {
  console.log(SIMULATE_PAYMENT_PREFIX, `Simulating a payment...`);

  const response = await PAYMENT_ENDPOINTS.simulate(data);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(SIMULATE_PAYMENT_PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(SIMULATE_PAYMENT_PREFIX, `Simulated a payment.`);
  return json as BaseResponse;
};